"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadFileToS3 = uploadFileToS3;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function uploadFileToS3(file, referencia, tipo, onUploadPreviewFoto, sendFiles, id_album) {
  const mimetypeAccepted = ['image/jpg', 'image/jpeg', 'image/png'];
  const fileToUpload = file.files;
  let archivos = [];

  _lodash.default.map(fileToUpload, uniqueFile => {
    const mimetype = uniqueFile.type; // reviso que la extension del archivo sea la correcta

    if (!mimetypeAccepted.includes(mimetype)) {
      alert(' El tipo de archivo que esta intentando subir, es invalido ');
      return false;
    } // creo un nuevo blob a partir del archivo
    //const fileContent = uniqueFile.slice(0, -1, mimetype);
    // genero un nombre para la foto


    const fileName = createFileName(referencia, tipo, 8, mimetype); // creamos un archivo con el mismo contenido para poder cambiar el nombre. File.Name es readOnly

    const newFile = new File([uniqueFile], fileName, {
      type: mimetype
    }); // creamos una URL BLOB para la imagen.

    const url = window.URL.createObjectURL(newFile);
    archivos.push({
      'fileName': newFile.name,
      'file': newFile,
      'type': mimetype,
      'id_album': id_album
    }); // asignamos la URL BLOB a la img correspondiente.

    onUploadPreviewFoto(url, newFile.name);
  });

  sendFiles(archivos);
}

function createFileName(ref, tipo, length, mimetype) {
  let timestamp = Date.now();
  let letras = "ACDEFGHJLMNOQRSTUWXZ";
  var randomChars = letras + timestamp;
  var result = '';

  for (var i = 0; i < length; i++) {
    result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
  }

  let fileExtension = '';

  if (mimetype == "image/png") {
    fileExtension += '.png';
  } else if (mimetype == "image/jpeg" || mimetype == "image/jpg") {
    fileExtension += '.jpg';
  }

  let newFileName = ref + '_' + tipo.replace(['á', 'é', 'í', 'ó', 'ú', 'ñ'], ['a', 'e', 'i', 'o', 'u', 'n']) + '_' + result + fileExtension;
  return newFileName.replace(' ', '-', newFileName);
}